import React from 'react';

interface CalendarMonthButtonProps {
    direction: 'prev' | 'next';
    date: Date;
    locale: string;
    onClick: () => void;
}

const MONTH_BUTTON_FORMAT = {
    prev: { arrow: '←', order: ['arrow', 'date'] },
    next: { arrow: '→', order: ['date', 'arrow'] },
} as const;

export function CalendarMonthButton({
    direction,
    date,
    locale,
    onClick,
}: CalendarMonthButtonProps) {
    const formattedDate = React.useMemo(
        () => date.toLocaleDateString(locale, { month: 'long', year: 'numeric' }),
        [date, locale]
    );

    const content = MONTH_BUTTON_FORMAT[direction].order
        .map((part) => (part === 'arrow' ? MONTH_BUTTON_FORMAT[direction].arrow : formattedDate))
        .join(' ');

    return (
        <button
            onClick={onClick}
            type="button"
            aria-label={`View ${formattedDate}`}
            className="btn bg-white text-backgroundGreen font-auditorium inline-flex items-center justify-center p-4 border-backgroundGreen border hover:bg-backgroundGreen hover:text-white transition-colors"
        >
            {content}
        </button>
    );
}
